/*
 * Copyright 2026 North Carolina State University
 */

import React from 'react';
import FormWorkspace from '../components/FormWorkspace';

const IpmControls = () => (
  <FormWorkspace
    kind="controls"
    title="List of Controls"
    subtitle="The pesticides, biological agents and other products available to apply. Controls added here can be picked on data-entry forms."
    emptyText="The List of Controls has no form yet. Create one, or start from the standard one (commercial name, active ingredient, REI, PPE, …) and adjust it."
    starterLabel="Use the starter form"
    entryInDialog
    allColumns
  />
);

export default IpmControls;
